import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactTopSection from './sections/ContactTopSection';
import ContactFormSection from './sections/ContactFormSection';

const SectionDivider = () => (
  <div className="w-full h-px bg-accent-500/30" />
);

export default function Contact() {
  useEffect(() => {
    document.title = 'Contact | MANDIE OZEE.';
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <ContactTopSection />
        <SectionDivider />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
}